var $mainContent = $("#main-content");
var $pcHeader = $(".pc-header");
var $mobileHeader = $(".mobile-header");
var $liveBlock = $("#live-video-block");

function refinedMainBlockPadding() {
	if (window.matchMedia("(min-width: 992px)").matches) {
		$mainContent.css({ "padding-top": $pcHeader.outerHeight() });
		if ($liveBlock.length !== 0) {
			$mainContent.css({ "padding-top": $mobileHeader.outerHeight() });
		}
	} else {
		$mainContent.css({ "padding-top": $mobileHeader.outerHeight() });
	}
}
refinedMainBlockPadding();

$(window).resize(refinedMainBlockPadding);
